module.exports = __webpack_public_path__ + "assets/b111.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b111.png
// module id = 583
// module chunks = 0